import * as React from 'react';
import { 
    ContextMenu, DialogWrapper, ErrorBoundary,
} from "@/components";

export const EditorReactHost = () => {
    return (
        <ErrorBoundary>
            <DialogWrapper />
            <ContextMenu />
        </ErrorBoundary>
    );
}
